export default __webpack_public_path__ + "static/sitting_on_sofa-f78be3f847c56ee44bd422c13f511f57.jpg";